// charge bootstrap
import 'bootstrap/js/dist/button'
import Modal from 'bootstrap/js/dist/modal'

// Styles
import '../../scss/components/quickSearchModal'
import '../../scss/components/forms'

const qsModal = {
  $modal: document.getElementById('quick-search-modal'),
  modalId: 'quick-search-modal',
  $open: document.querySelectorAll('.qsModal'),

  init () {
    const self = this
    let el
    let elClone

    // remove all listeners to search button : https://stackoverflow.com/questions/19469881/remove-all-event-listeners-of-specific-type
    el = self.$modal.querySelector('button[name="search"]')
    elClone = el.cloneNode(true)
    el.parentNode.replaceChild(elClone, el)
    // set event to search button
    const searchBtnFn = () => {
      const form = self.$modal.querySelector('form')
      const dep = form.querySelector('input[name="dep"]:checked').value
      const type = form.querySelector('input[name="type"]:checked').value
      form.setAttribute('action', '/' + type)
      if (type !== 'modeles-de-maisons' && dep !== '0') {
        form.setAttribute('action', form.getAttribute('action') + '/' + dep)
      }
      if (typeof (googletag) !== 'undefined') {
        /* global gtag */
        gtag('event', 'quick_search', { action: 'submit' })
      }
      form.submit()
    }
    self.$modal.querySelector('button[name="search"]').addEventListener('click', searchBtnFn)

    // remove all listeners to close button : https://stackoverflow.com/questions/19469881/remove-all-event-listeners-of-specific-type
    el = self.$modal.querySelector('button[name="close"]')
    elClone = el.cloneNode(true)
    el.parentNode.replaceChild(elClone, el)
    // set event to close button
    const cancelBtnFn = () => {
      self.myModal.hide()
    }
    self.$modal.querySelector('button[name="close"]').addEventListener('click', cancelBtnFn)

    // reset open event
    const openQsModalFn = () => {
      self.myModal = new Modal(document.getElementById(self.modalId))
      self.$modal.classList.remove('visually-hidden')
      self.myModal.show()
      if (typeof (googletag) !== 'undefined') {
        gtag('event', 'quick_search', { action: 'show' })
      }
    }
    self.$open.forEach(b => {
      const bClone = b.cloneNode(true)
      b.parentNode.replaceChild(bClone, b)
    })
    document.querySelectorAll('.qsModal').forEach(b => {
      b.addEventListener('click', openQsModalFn)
    })

    // force l'ouverture de la recherche rapide
    self.$open[0].click()
  }
}

qsModal.init()
